import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tablist',
  templateUrl: './tablist.component.html',
  styleUrls: ['./tablist.component.scss']
})
export class TablistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
